// Platinum
export default [
    {type: "freeplay", to: "$7"},
    {type: "weekly_rakeback", to: "12%"},
    {type: "monthly_rakeback", to: "10%"},
    {type: "birthday_bonus", to: "$20 + 17%"},
    {type: "deposit_assist_token", to: "$2"}
]